// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { IsNotEmpty } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface IDeviceAccessToken {
	deviceName: string | undefined;

	id: string | undefined;

	deviceId: string;

	token: string;

	dateCreated: string | undefined;

	createdById: string | undefined;

	expiresAt: string | undefined;

	revokedAt: string | undefined;

	label: string | undefined;

	lastUsedAt: string | undefined;

	$type?: string | undefined;
}
export class DeviceAccessToken {
	constructor(data?: IDeviceAccessToken) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.dateCreated) { this.dateCreated = new Date(data.dateCreated); }
		if (data.expiresAt) { this.expiresAt = new Date(data.expiresAt); }
		if (data.revokedAt) { this.revokedAt = new Date(data.revokedAt); }
		if (data.lastUsedAt) { this.lastUsedAt = new Date(data.lastUsedAt); }
	}

	deviceName: string | undefined;

	id: string | undefined;

	@IsNotEmpty()
	deviceId: string = "";

	@IsNotEmpty()
	token: string = "";

	dateCreated: Date | undefined = new Date();

	createdById: string | undefined;

	expiresAt: Date | undefined;

	revokedAt: Date | undefined;

	label: string | undefined;

	lastUsedAt: Date | undefined;

	static $type: string = "CoreApi.Models.DeviceAccessToken, ";
	$type?: string | undefined = DeviceAccessToken.$type;
}

